module.exports = __webpack_public_path__ + "img/zj.4cca7f9d.gif";